import value from './value.js';
import { debounce, booleanDataset } from './utils.js';

class TopBar extends HTMLElement {
  #state = {
    isTop: value(null, { type: Boolean, nullable: true }),
    scrollDirection: value(null, { type: String, nullable: true })
  };

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve));
    this.#listeners();
    this.#scrollHandle();
  }

  #listeners() {
    this.#state.isTop.addEventListener('watch', ({ detail }) => {
      booleanDataset(this, 'top', detail.value);
    });

    this.#state.scrollDirection.addEventListener('watch', ({ detail }) => {
      this.dataset.direction = detail.value ? detail.value : '';
    });
  }

  #scrollHandle() {
    let y = window.scrollY;

    const scrollTest = function () {
      const currentY = window.scrollY;

      this.#state.isTop.set(currentY <= 0);

      if (currentY > y && !this.#state.isTop.get()) {
        this.#state.scrollDirection.set('down');
      }
      else if (currentY < y) {
        this.#state.scrollDirection.set('up');
      }
      else {
        this.#state.scrollDirection.set(null);
      }

      y = currentY;
    }.bind(this);

    // immediate call
    scrollTest();

    window.addEventListener('scroll', debounce(scrollTest, 15));
  }
}

customElements.define('top-bar', TopBar);
